
export const RESOURCES_PRICES = {
  FOOD: 10,
  GAS: 10,
};
